import { Suspense, lazy } from 'react';

import { KDErrorBoundary } from '@/components';
import { KDLayoutDashboardLoader } from '@/layouts';

const ItemsPage = lazy(() => import('./Items.page'));

export const Items = () => {
  return (
    <KDErrorBoundary>
      <Suspense fallback={<KDLayoutDashboardLoader />}>
        <ItemsPage />
      </Suspense>
    </KDErrorBoundary>
  );
};
